import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../helpers/helper';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ReportesService } from '../../services/reportes.service';
import { EmpleadosServicio } from '../../services/empleado.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-actividades',
  templateUrl: './actividades.component.html',
  styleUrls: ['./actividades.component.css']
})
export class ActividadesComponent implements OnInit {
  actividades = [];
  tipoActividades = [];
  loaded = false;
  loading = false;
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  empleados = [];
  actividadSeleccionada = '';
  active: number;
  datosEmpleado: any;
  empleadosSeleccionados = [];
  multiSelectEmpleado: any;


  constructor(
    private helper: Helper,
    private route: ActivatedRoute,
    private router: Router,
    private reporteService: ReportesService,
    private empleadoService: EmpleadosServicio) {
      this.datosEmpleado = this.empleadoService.datosEmpleado;
      if (this.datosEmpleado.tipo_empleado !== 3) {
        this.router.navigate(['/404']);
      }
      this.initEmpleados();
      this.initTipoActividades();
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();
  }

  private initConfigMultiSelect() {
    this.multiSelectEmpleado = {
      singleSelection: false,
      text: 'Seleccionar empleado',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  filtrarActividades() {

    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams['fecha_inicia'];
    delete queryParams['fecha_termina'];
    delete queryParams['incluir'];
    delete queryParams['limite'];
    delete queryParams['tipo_actividad'];
    delete queryParams['empleado'];

    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    if (this.actividadSeleccionada) {
      queryParams['tipo_actividad'] = this.actividadSeleccionada;
    }

    const empleados = this.empleadosSeleccionados.map(data => data.id).join();
    if (empleados) {
      queryParams['empleados'] = empleados;
    } else {
      delete queryParams['empleados'];
    }

    if (this.limit) {
      queryParams['limite'] = this.limit;
    }
    this.router.navigate(['./actividades'], { queryParams: queryParams });
  }

  verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        if (params.limite) {
          this.limit = params.limite;
        }

        if (params.fecha_inicia || params.fecha_termina) {

          if (params.fecha_inicia) {
            const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
            const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
            const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

            if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_termina) {
            const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

            if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        } else if (params.fecha) {
          const yearInit = parseFloat(params.fecha.split('-')[0]);
          const monthInit = parseFloat(params.fecha.split('-')[1]);
          const dayInit = parseFloat(params.fecha.split('-')[2]);

          const yearEnd = parseFloat(params.fecha.split('-')[0]);
          const monthEnd = parseFloat(params.fecha.split('-')[1]);
          const dayEnd = parseFloat(params.fecha.split('-')[2]);
          if ( (!isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit )) &&
               (!isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd )) ) {
            this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
          }
        }

        if (params.empleados) {
          this.empleadosSeleccionados = [];
          for (const empleado of this.empleados) {
            for (const empleadoSeleccionado of params.empleados.split(',')) {
              if (parseFloat(empleadoSeleccionado) === empleado.id) {
                this.empleadosSeleccionados.push(empleado);
              }
            }
          }
        }

        if (!isNaN(params.tipo_actividad)) {
          this.actividadSeleccionada = params.tipo_actividad;
        }

        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        this.initActividades();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./actividades'], { queryParams: queryParams });
  }

  private initActividades() {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde !== undefined && this.fecha_desde !== null && this.fecha_desde.year !== null) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta !== undefined && this.fecha_hasta !== null && this.fecha_hasta.year !== null) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    const fechas = { fecha_desde, fecha_hasta };
    // tslint:disable-next-line:max-line-length
    this.reporteService.obtenerActividades(fechas, this.empleadosSeleccionados.map(data => data.id).join(), this.actividadSeleccionada, this.limit, this.offset)
    .subscribe((res: any) => {
      this.active = parseFloat(localStorage.getItem('actividad_active')) || -1;
      this.actividades = res.actividades;
      this.size = res.total_items;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  initEmpleados() {
    const titleCase = new TitleCasePipe();
    this.empleadoService.empleadoActividades()
    .subscribe(result => {
      for (const empleado of result) {
        this.empleados.push({
          id: empleado.ID_EMPLEADO,
          itemName: `${ titleCase.transform(empleado.empleado) } (${ empleado.tipo_empleado == 3 ? 'Super Admin' : (empleado.tipo_empleado == 1 ? 'Admin' : 'Cobrador') })`
        });
      }
    });
  }

  initTipoActividades() {
    this.reporteService.tipoActividades()
    .subscribe((result: any) => {
      this.tipoActividades = result;
    });
  }

  navigate(actividad, tipo: number) {
    localStorage.setItem('actividad_active', (actividad.ID));

    if (tipo === 1) {

      switch (actividad.ID_TIPO_ACTIVIDAD) {
        case 4:
        case 5:
        case 6:
        case 8:
        case 13:
        case 14:
        case 15:
        case 24:
        case 33:
        case 34:
        case 35:
        case 41:
        case 42:
          this.router.navigate(['/prestamo', actividad.ID]);
        break;
        case 7:
        case 3:
          this.router.navigate(['/ruta', actividad.ID]);
        break;
        case 1:
        case 9:
        case 10:
        case 11:
        case 12:
        case 23:
        case 26:
          this.router.navigate(['/cliente', actividad.ID]);
        break;
        case 16:
          this.router.navigate(['/lista/recibos'], { queryParams: { r: actividad.ID } });
        break;
        case 17:
        case 18:
        case 20:
        case 21:
        case 36:
        case 39:
          this.router.navigate(['/lista/apertura-dia']);
        break;
        case 19:
          this.router.navigate(['/lista/gastos-dietas']);
        break;
        case 22:
          this.router.navigate(['/configurar/prestamos']);
        break;
      }
    } else {
      this.router.navigate(['/empleado', actividad.quien]);
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/actividades/actividades.component.ts